import RelationshipMetadata from "../../RelationshipMetadata";

class EmployeeEmployeeAdminPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EmployeeEmployeeAdminPositionRelationshipMetadata";
        this.parentEnterpriseComponent = "Employee";
        this.childEnterpriseComponent = "EmployeeAdminPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "PositionUSID";
    }
}

export default EmployeeEmployeeAdminPositionRelationshipMetadata;